<template>
  <div class="scanner-delivery-in-store-view">
    <div class="header-container">
      <span class="header-title">{{ headerTitle }}</span>
    </div>

    <div class="camera-select-row">
      <label class="camera-select-label">Cámara</label>
      <b-form-select
        v-model="selectedCameraId"
        :options="cameraOptions"
        size="sm"
        class="camera-select"
      />
    </div>

    <div class="scan-zone">
      <scanner-delivery-in-store
        ref="scanner"
        :scan-type="scanType"
        :initial-camera-id="selectedCameraId"
        @camera-needed="onCameraNeeded"
      />
    </div>
  </div>
</template>

<script>
import ScannerDeliveryInStore from '../components/delivery/ScannerDeliveryInStore.vue'
import { Html5Qrcode } from 'html5-qrcode'

const CAMERA_STORAGE_KEY = 'scanner_selected_camera_id'

export default {
  name: 'ScannerDeliveryInStoreView',
  components: { ScannerDeliveryInStore },
  data() {
    return {
      scanType: 'pickedUpAtStore',
      cameras: [],
      selectedCameraId: localStorage.getItem(CAMERA_STORAGE_KEY) || null
    }
  },
  computed: {
    headerTitle() {
      return 'Escanear recepcionados en tienda'
    },
    cameraOptions() {
      return this.cameras.map((cam, idx) => ({
        value: cam.id,
        text: cam.label || `Cámara ${idx + 1}`
      }))
    }
  },
  watch: {
    async selectedCameraId(newId, oldId) {
      if (!newId || newId === oldId) return
      localStorage.setItem(CAMERA_STORAGE_KEY, newId)
      // Propagar el cambio al componente scanner (que reinicia internamente)
      if (this.$refs.scanner) {
        this.$refs.scanner.setCamera(newId)
      }
    }
  },
  async mounted() {
    await this.loadCameras()
  },
  beforeRouteLeave(to, from, next) {
    // Si el usuario navega a otra ruta, opcionalmente limpiar la lista.
    // Por ahora dejamos que persista en localStorage para no perder trabajo.
    next()
  },
  methods: {
    async loadCameras() {
      try {
        this.cameras = await Html5Qrcode.getCameras()
        if (this.cameras.length && !this.selectedCameraId) {
          const backCamera = this.cameras.find(c =>
            /back|rear|environment/i.test(c.label || '')
          )
          this.selectedCameraId = backCamera ? backCamera.id : this.cameras[0].id
        }
      } catch (error) {
        // El componente QrScanner maneja el error de permisos internamente
        this.cameras = []
      }
    },
    onCameraNeeded() {
      // Hook por si en el futuro queremos re-popular cameras desde acá
    },
    goBack() {
      this.$router.push('/envios')
    }
  }
}
</script>

<style lang="scss" scoped>
.scanner-delivery-in-store-view {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  height: calc(100% - 120px);
}

.header-container {
  margin: 0.5rem;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.back-btn {
  background-color: #fff !important;
  border: none !important;
  padding: 0.7rem !important;
  width: fit-content !important;
  display: flex !important;
  align-items: center !important;
  border-radius: 30px !important;

  .material-icons {
    color: #181818;
  }
}

.header-title {
  padding-left: 0.5rem;
  font-weight: 600;
  font-size: 1rem;
}

.camera-select-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.4rem 0.75rem;
  flex-shrink: 0;
}

.camera-select-label {
  font-size: 0.85rem;
  white-space: nowrap;
  margin: 0;
  flex-shrink: 0;
}

.camera-select {
  flex: 1;
  max-width: 280px;
}

.scan-zone {
  flex: 1;
  display: flex;
  min-height: 0;
  overflow: hidden;
}
</style>